import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class StringFormattingService {
  constructor(private readonly translateService: TranslateService) {}

  formatList(items: string[], max?: number): string {
    if (items.length === 1) {
      return items[0];
    }
    if (!!max && items.length > max) {
      const moreItems = items.splice(max);
      return (
        items.join(', ') +
        this.translateService.instant('AUTOMATIONS.EDITOR.TASKS.SEND_NOTIFICATIONS.ACTIVITY.AND_MORE', {
          count: `${moreItems.length}`,
        })
      );
    } else {
      // E.g. en: Apples and Oranges
      // E.g.: en: Apples, Oranges, and Bananas
      // E.g.: fr: Apples, Oranges, et Bananas
      const OXFORD_COMMA = ',',
        NO_COMMA = '';
      return (
        items.slice(0, -1).join(', ') +
        [
          items.length >= 3 ? OXFORD_COMMA : NO_COMMA,
          this.translateService.instant('AUTOMATIONS.EDITOR.TASKS.REMOVE_TAG.AND').toLowerCase(),
          items[items.length - 1],
        ].join(' ')
      );
    }
  }
}
